export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-white">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <span className="font-heading text-xl font-bold text-white mb-3 block">
              97<span className="text-accent-400">影院</span>
            </span>
            <p className="text-xs text-white/50 leading-relaxed">
              电影大全免费在线观看平台，提供最新电影、热播电影、经典电影的高清蓝光在线播放服务。动作片、喜剧片、科幻片应有尽有，不卡顿流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">精选专题</a>
              <a href="#carousel" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">焦点推荐</a>
              <a href="#ranking" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">热门排行</a>
              <a href="#faq" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-3">电影分类</h4>
            <div className="space-y-2">
              <a href="#topics" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">动作大片</a>
              <a href="#topics" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">科幻巨制</a>
              <a href="#topics" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">喜剧精选</a>
              <a href="#topics" className="block text-xs text-white/50 hover:text-accent-400 transition-colors cursor-pointer">悬疑烧脑</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white/80 mb-3">合作伙伴</h4>
            <p className="text-xs text-white/40 leading-relaxed">
              诚邀各大影视平台、媒体机构合作共赢。合作洽谈请通过联系页面发送邮件。
            </p>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            &copy; 2018-2025 97影院网 版权所有 | 电影大全免费在线观看
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-white/40 hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-white/40 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a>
            <a href="#about" className="text-xs text-white/40 hover:text-accent-400 transition-colors cursor-pointer">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}